import { ChangeDetectionStrategy, Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-ph-progress-bar',
  templateUrl: './ph-progress-bar.component.html',
  styleUrls: ['./ph-progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhProgressBarComponent implements OnInit {
  @Input() private total = 0;
  @Input() private current = 0;
  @Input() isClosed = false;

  progress: number;
  percentage: number;

  ngOnInit() {
    this.calculate();
  }

  calculate(): void {
    if (Number(this.current) !== 0 && Number(this.total) !== 0) {
      const mod = (this.current / this.total) * 100;
      this.percentage = Math.floor(mod);
      this.progress =
        this.percentage > 100 ? this.calculateIfIsOverAndInt(this.percentage) : this.percentage;
    } else {
      this.percentage = 0;
      this.progress = 0;
    }
  }
  calculateIfIsOverAndInt(percentage: number): number {
    const parsedPercentage = percentage.toString();
    return Number(parsedPercentage.slice(0, 3)) - Number(parsedPercentage.slice(0, 1)) * 100;
  }

  getProjectBarContainerColor(): string {
    if (this.isClosed) {
      if (this.percentage > 100) {
        return 'progress-bar-closed';
      }
      return 'primary-container';
    } else {
      if (this.percentage > 100) {
        return 'primary';
      }
      return 'primary-container';
    }
  }

  getProjectBarColor(): string {
    if (this.isClosed) {
      if (this.percentage > 100) {
        return 'over-color-bar-closed';
      }
      return 'progress-bar-closed';
    } else {
      if (this.percentage > 100) {
        return 'over-color-bar';
      }
      return 'primary';
    }
  }
}
